import * as exports from '.'

export { default as Button } from './Button'
export { default as Divider } from './Divider'

export default exports
